import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import SubscriptionTable from './SubscriptionTable';
const Subscription = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Subscription' parent='Subscription'  />
      <Container fluid={true}>
        <Row>
          <SubscriptionTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Subscription;